var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bd-content"},[_c('div',{staticClass:"bd-example vue-example vue-example-b-embed"},[_c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('youtube',{staticClass:"wd-100p",attrs:{"video-id":_vm.videoId}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }